// ** MUI Imports
import Fab from "@mui/material/Fab";
import AppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import MuiToolbar from "@mui/material/Toolbar";
// ** Icons Imports
import ArrowUp from "mdi-material-ui/ArrowUp";
// ** Theme Config Import
import themeConfig from "src/configs/themeConfig";

// ** Components
import Customizer from "src/@core/components/customizer";
import Footer from "./components/shared-components/footer";
// import Navigation from "./components/horizontal/navigation";
import Navigation from "./components/horizontal/navigation";
import ScrollToTop from "src/@core/components/scroll-to-top";
import AppBarContent from "./components/horizontal/app-bar-content";

// ** Styled Component
import DatePickerWrapper from "src/@core/styles/libs/react-datepicker";
// import Avatar from '../components/mui/avatar'
import {
  Box,
  Button,
  Typography,
  useScrollTrigger,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
// import Logo from '../../assets/images/Logo.png'
import Translations from "src/layouts/components/Translations";
// import Bg from "../../assets/images/bg.png";
import React from "react";

import { Link, useLocation } from "react-router-dom";
// import Logo from '../components/logo'
import { useState } from "react";
import Logo from "../components/logo";
import { useTranslation } from "react-i18next";

const HorizontalLayoutWrapper = styled("div")({
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  ...(themeConfig.horizontalMenuAnimation && { overflow: "clip" }),
});

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: "100%",
  padding: `${theme.spacing(0, 6)} !important`,
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(4),
  },
  [theme.breakpoints.down("xs")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const ContentWrapper = styled("main")(({ theme }) => ({
  flexGrow: 1,
  width: "100%",
  // padding: theme.spacing(6),
  // transition: 'padding .25s ease-in-out',
  // [theme.breakpoints.down('sm')]: {
  //   paddingLeft: theme.spacing(4),
  //   paddingRight: theme.spacing(4)
  // }
}));

const HorizontalLayout = (props) => {
  const location = useLocation();
  const { i18n, t } = useTranslation();
  // ** Props
  const {
    hidden,
    children,
    settings,
    scrollToTop,
    saveSettings,
    horizontalNavMenuContent: userHorizontalNavMenuContent,
  } = props;

  // ** Vars
  const { skin, appBar, navHidden, appBarBlur, contentWidth } = settings;

  function ChangeColorOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
      style: {
        // backgroundColor: trigger ? "#fff" : "transparent",
        color: trigger ? "#000" : "transparent",
      },
    });
  }


  const handleLanguageChange = (event) => {
    const nextLang = event.target.value;
    i18n.changeLanguage(nextLang);
    saveSettings({ ...settings, direction: nextLang === "ar" ? "rtl" : "ltr" });
  };
  return (
    <HorizontalLayoutWrapper className="layout-wrapper">
      <ChangeColorOnScroll {...props}>
        <AppBar
          color="default"
          // elevation={skin === "bordered" ? 0 : 3}
          className="layout-navbar-and-nav-container"
          position={appBar === "fixed" ? "sticky" : "static"}
          sx={{
            boxShadow: "none",
            py: 3,
            bgcolor: "#FFFFFF",
            borderBottom: "1px solid #F2EFE2",
          }}
        >
          <Box
            className="layout-navbar"
            // sx={{
            //   // width: "100%",
            //   // bgcolor: "#0C7362",
            //   // borderRadius: "10px",
            //   // height: "41px",
            //   ...(navHidden
            //     ? {}
            //     : {
            //         borderBottom: (theme) =>
            //           `1px solid ${theme.palette.divider}`,
            //       }),
            // }}
            sx={{ px: "65px" }}
          >
            {/* <Toolbar
              className="navbar-content-container"
              // sx={{
              //   mx: "auto",
              //   height: "41px !important",
              //   ...(contentWidth === "boxed" && {
              //     "@media (min-width:1440px)": { maxWidth: 1440 },
              //   }),
              //   minHeight: (theme) =>
              //     `${theme.mixins.toolbar.minHeight - 1}px !important`,
              // }}
            >
              <AppBarContent
                {...props}
                hidden={hidden}
                settings={settings}
                saveSettings={saveSettings}
              />
            </Toolbar> */}
          </Box>

          {navHidden ? null : (
            <Box
              className="layout-horizontal-nav"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: "100%",
                px: "50px",
                // paddingLeft: "170px",
              }}
            >
              <Link to="/" style={{ textDecoration: "none" }}>
                <Logo />
              </Link>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Toolbar
                  className="horizontal-nav-content-container"
                  sx={{
                    bgcolor: "primary",
                    mx: "auto",
                    height: "100%",
                    ...(contentWidth === "boxed" && {
                      "@media (min-width:1440px)": { maxWidth: 1440 },
                    }),
                    // minHeight: theme => `${theme.mixins.toolbar.minHeight - (skin === 'bordered' ? 1 : 0)}px !important`
                  }}
                >
                  {(userHorizontalNavMenuContent &&
                    userHorizontalNavMenuContent(props)) || (
                    <Navigation {...props} />
                  )}
                </Toolbar>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // mr: 10,
                    gap: { xs: 2, md: 5 },
                  }}
                >
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: "unset",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #D33D4F !important",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Select
                      value={i18n.language}
                      onChange={handleLanguageChange}
                      sx={{
                        color: "#D33D4F",
                        fontWeight: 700,
                        fontSize: "16px",
                        // height: "38px",
                        "& .MuiSelect-select": {
                          py: 3.5,
                          px: 3,
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    >
                      <MenuItem value="en">En</MenuItem>
                      <MenuItem value="ar">Ar</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    as={Link}
                    size="small"
                    // to="/it-solution-supportUs"
                    sx={{
                      textDecoration: "none",
                      // borderRadius: "16px",
                      // padding: "3px 24px",
                      fontSize: "16px",
                      fontWeight: 700,
                      textWrap: "nowrap",
                      px: 3,
                    }}

                    // onClick={handleDialogOpen}
                  >
                    {t("Become a Driver")}
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </AppBar>
      </ChangeColorOnScroll>

      <ContentWrapper
        className="layout-page-content"
        sx={{
          ...(contentWidth === "boxed" && {
            mx: "auto",
            "@media (min-width:1440px)": { maxWidth: 1440 },
            "@media (min-width:1200px)": { maxWidth: "100%" },
          }),
        }}
      >
        {children}
      </ContentWrapper>

      <Footer {...props} />

      <DatePickerWrapper sx={{ zIndex: 11 }}>
        <Box id="react-datepicker-portal"></Box>
      </DatePickerWrapper>

      {themeConfig.disableCustomizer || hidden ? null : <Customizer />}

      {/* {scrollToTop ? (
        scrollToTop(props)
      ) : (
        <ScrollToTop className="mui-fixed">
          <Fab color="primary" size="small" aria-label="scroll back to top">
            <ArrowUp />
          </Fab>
        </ScrollToTop>
      )} */}
    </HorizontalLayoutWrapper>
  );
};

export default HorizontalLayout;
